import { MapFeatureInfoHeader as View } from 'ui-components'
import { useFeatureInfo } from '~map-feature-info/states/map'
import { find } from 'lodash'

export const MapFeatureInfoHeader = () => {
  const feature = useFeatureInfo()
  const title = find(feature?.properties, { isTitle: true })

  return <View title={title?.value} />
}
